import { Language } from '@vae/server/dist/client'
import dayjs from 'dayjs'
import { TFunction } from 'i18next'
import i18n from '../../../../i18n'
import { getMonthString } from '../../../../modules/consumptionDataParser'
import { timePeriods } from '../../constants/scoreboardConstants'
import { TimePeriodData } from '../../types/timePeriodData'

export const generateTimePeriods = (t?: TFunction<'pages_saving', undefined>): TimePeriodData[] => {
	const currentMonth = dayjs()
	const lastMonth = currentMonth.subtract(1, 'month')
	const language = (i18n.language as Language) ?? Language.fi

	return [
		{
			id: timePeriods.allTime,
			title: t ? t('timePeriods.allTime') : 'Koko aika',
			subtitle: t ? t('timePeriods.allPeriods') : 'Kaikki kaudet',
		},
		{
			id: timePeriods.last,
			title: t ? t('timePeriods.previousPeriod') : 'Edellinen kausi',
			subtitle: getMonthString(lastMonth.month() + 1, language) + ' ' + lastMonth.year(),
		},
	]
}
